import ModalButtons from "../ModalButtons/ModalButtons"
//import I18n from "i18n-js/index.js.erb"

class AutoPriceRuleBuilderButtons extends React.Component {

	constructor(props) {
		super(props);
  }

	render() {
    var self = this;

    if (this.props.nested) {
    	return null;
    } else if (this.props.read_only) {
	    var buttons = [
	      {
	        name: I18n.t('ok'),
	        html_attributes: [
	          'data-dismiss="modal"'
	        ]
	      },
	    ];

			return (
				<ModalButtons loading={this.state.loading} buttons={buttons} />
			);
    } else {
	    var buttons = [
	      {
	        name: I18n.t('cancel'),
	        html_attributes: [
	          'data-dismiss="modal"'
	        ]
	      },
	      {
	        name: I18n.t('submit'),
	        button_classes: ['primary'],
	        onClick: function (e) {
	          e.stopPropagation();
	          e.preventDefault();

	          self.props.onSave();
	        }
	      }
	    ];

			return (
				<ModalButtons loading={this.state.loading} buttons={buttons} />
			);
    }
	}

};

export default AutoPriceRuleBuilderButtons